import CandidateFilter from './CandidateFilter.container';

export default CandidateFilter;
